<template>
  <div class="important-date">
    <base-field
      :value="value.name"
      name="event name"
      type="text"
      :invalid="invalidEvent('event_name')"
      required
      @input="updateName"
    >
      {{ text.eventName }}
    </base-field>
    <div class="important-date__calendar">
      <important-calendar
        :value="value.date"
        :placeholder="text.selectDate"
        :invalid="invalidEvent('event_date')"
        @input="updateDate"
      />
    </div>
    <button
      v-if="!notRemovable"
      class="important-date__remove"
      @click="emitRemove"
    />
  </div>
</template>

<script>
import BaseField from './base/base-field'
import ImportantCalendar from './important-calendar'
export default {
  name: 'ImportantDate',
  components: {ImportantCalendar, BaseField},
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    text: {
      type: Object,
      default: () => {}
    },
    notRemovable: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    emitRemove() {
      this.$emit('remove', this.value.id)
    },
    updateName(name) {
      this.$emit('input', {...this.value, name})
    },
    updateDate(date) {
      this.$emit('input', {...this.value, date})
    },
    invalidEvent(event) {
      const array = this.invalid.filter(item => item[event])
      const [error] = array
      return error ? error[event] : null
    }
  }
}
</script>

<style lang="scss">
.important-date {
  display: flex;
  gap: 20px;
  align-items: center;

  &__calendar {
    flex-grow: 1;
  }

  &__remove {
    --bg-color: #C4C4C4;

    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border: none;
    outline: none;
    transform: rotate(45deg);
    cursor: pointer;

    &::after,
    &::before {
      position: absolute;
      width: 2px;
      height: 20px;
      background-color: var(--bg-color);
      border-radius: 19px;
      transition: background-color .3s;
      content: '';
    }

    &::after {
      transform: rotate(90deg);
    }

    &:hover {
      --bg-color: #333333;
    }
  }
}
</style>
